import { Injectable, Provider } from "@angular/core";
import { ContactRequestClient, ContactRequestSendCommand, ContactRequestSendCommandResult } from "../../INTEGRA_Shop_Client";
import { Observable } from "rxjs";
import { IContactRequestApiService, IContactRequestApiServiceToken } from "./contact-request-api-service.interface";

@Injectable({
  providedIn: 'root'
})
export class ContactRequestApiService implements IContactRequestApiService {

  constructor(
    private contactRequestClient: ContactRequestClient,
  ) { }

  public contactRequestSend(command: ContactRequestSendCommand): Observable<ContactRequestSendCommandResult> {
    return this.contactRequestClient.contactRequestSend(command);
  }
}

/**
 * Prepared provider with the token to implementation mapping.
 * Reference this at the desired provider list to enable the injection of this implementation by referencing the token(interface).
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const ContactRequestApiServiceProvider: Provider[] = [
  { provide: ContactRequestClient },
  { provide: IContactRequestApiServiceToken, useExisting: ContactRequestApiService }
];
